module.exports = __webpack_public_path__ + "static/media/file15.6d4ac6ac.jpg";